<dx-data-grid
  *ngIf="ready"
  [glamResource]="linksResource"
  [selection]="{ mode: 'none' }"
  [groupPanel]="{ visible: false }"
  [disabledAdd]="true"
  [disabledDelete]="true"
  (refreshEmit)="buildLinks()"
  >

  <dxo-editing
    mode="cell"
    [allowUpdating]="false"
    [allowDeleting]="false"
    [allowAdding]="false"
    />

  <dxi-column
    dataField="code" 
    [caption]="'entity.processSheet.code' | translate | ucfirst"
    cellTemplate="codeTemplate"
    >
    <div *dxTemplate="let cell of 'codeTemplate'" class="hover:underline cursor-pointer">
      <a (click)="navigateToProcessSheetEditor(cell.data)">{{ cell.value }}</a>
    </div>
  </dxi-column>

  <dxi-column
    dataField="routingName" 
    [caption]="'entity.processSheet.processSheet' | translate | ucfirst"
    cellTemplate="routingNameTemplate"
    >
    <div *dxTemplate="let cell of 'routingNameTemplate'" class="hover:underline cursor-pointer">
      <a (click)="navigateToProcessSheetEditor(cell.data)">{{ cell.value }}</a>
    </div>
  </dxi-column>

  <dxi-column
    dataField="version"
    [caption]="'entity.processSheet.version' | translate | ucfirst"
    cellTemplate="versionTemplate"
    >
    <div *dxTemplate="let cell of 'versionTemplate'" class="hover:underline cursor-pointer">
      <a (click)="navigateToProcessSheetEditor(cell.data)">{{ cell.value }}</a>
    </div>
  </dxi-column>

  <dxi-column
    dataField="documentTypeName"
    [caption]="'entity.documentType.documentType' | translate | ucfirst"
    >
  </dxi-column>

  <dxi-column
    dataField="revisionStateId"
    cellTemplate="stateTemplate"
    [caption]="'common.state' | translate | ucfirst"
    [alignment]="'center'"
    >
    <div *dxTemplate="let cell of 'stateTemplate'">
      <div class="px-3 py-1 rounded-full text-white" [style]="{backgroundColor: getStateColor(cell.data)}">
        {{ getStateName(cell.data) }}
      </div>
    </div>
  </dxi-column>

</dx-data-grid>